import {getStatusLabel, getStatusStyle} from '@/utils/functions'
import PickupTime from '@/customComponents/sharedComponents/PickupTime.jsx'
import {formatTripLocalTime, parseAppZoneDate} from '@/utils/dateUtils'

/**
 * BEFORE THERE IS ANYTHING TO TRACK — the ride is booked, nobody has set off.
 *
 * ── ⚠️ IT NAMES NO DRIVER, EVEN WHEN ONE IS ASSIGNED ──────────────────────────────
 * `Assigned` means a driver has been given the ride; `EnRoute` means they have set off for
 * it. `isDriverRevealed` in `utils/functions.js` draws the line at the second, and its own
 * note says why. So this screen talks about the RIDE — when it is booked for, where it is
 * going — and sends anyone wanting more to the trip page, which enforces the same rule.
 *
 * ── ⚠️ AND IT DOES NOT PROMISE A COUNTDOWN ────────────────────────────────────────
 * The temptation is "your driver will set off in about N minutes". Nothing in the API says
 * that: a driver leaves when they leave, and a made-up number on the page a worried
 * passenger opens is the worst place to be wrong. The scheduled time is a fact; the rest
 * is what the page says once it is true.
 */
export default function WaitingForTrip({trip, onViewTrip}) {
    const scheduled = parseAppZoneDate(trip?.scheduled_at)

    return (
        <div className="mx-auto w-full max-w-2xl">
            <section className="white-global-section text-center max-md:p-3! max-md:shadow-none! max-md:rounded-2xl! max-md:border max-md:border-(--border-color)">
                {/* THE SAME PILL THE REST OF THE PORTAL DRAWS — `getStatusStyle` keyed on
                    the raw status, exactly as the ride-details header and the upcoming-ride
                    card do it.

                    ⚠️ THE COLOUR IS NOT DECORATION, WHICH IS WHY IT IS NOT HARDCODED GREEN.
                    That function assigns a different one per phase and carries an animation
                    with one of them: green for Accepted and Assigned, an amber PING for
                    Requested and Broadcasted while dispatch is still looking, red for a
                    failed payment hold. This screen shows every one of those states, so
                    pinning it to green would tell a passenger whose hold has just failed
                    that everything is fine. */}
                <p className="mb-4!">
                    <span className={`${getStatusStyle(trip?.status)} inline-block rounded-full px-6 py-2.5 max-md:px-4`}>
                        {getStatusLabel(trip?.status_label, trip?.status)}
                    </span>
                </p>

                <p className="mb-4! text-2xl font-bold max-md:text-lg">
                    {scheduled
                        ? <>Your ride is booked for <PickupTime trip={trip} format={(v) => formatTripLocalTime(parseAppZoneDate(v))} inline/></>
                        : 'Your ride is booked'}
                </p>

                <p className="mb-6! text-(--text-secondary)">
                    Live tracking opens the moment your driver sets off for the pickup. Until then
                    there is no car on the road to follow.
                </p>

                <button
                    type="button"
                    onClick={onViewTrip}
                    className="inline-flex cursor-pointer items-center justify-center gap-2 rounded-full border-0 bg-(--text-primary) px-8 py-4 font-medium text-white"
                >
                    View trip details
                    <span aria-hidden="true">›</span>
                </button>
            </section>
        </div>
    )
}

export {WaitingForTrip}
